export const state = {
  sideBarOpen: true,
  toggleSpeedStatus: false,
  notifSideBarOpen: JSON.parse(localStorage.getItem('notifSideBarOpen')) || false,
}

export const getters = {
  g_sideBarOpen: (state) => state.sideBarOpen,
}

export const mutations = {
  toggleSideBar(state) {
    state.sideBarOpen = !state.sideBarOpen
  },
  toggleSpeed(state) {
    state.toggleSpeedStatus = !state.toggleSpeedStatus
  },
  toggleNotifSideBar(state, payload) {
    state.notifSideBarOpen = payload
    localStorage.setItem('notifSideBarOpen', JSON.stringify(payload))
  },
}
